<app-help-page mainVideo="managing-dimensions"
               [tutorials]="['dimensions-in-adloop', 'metrics-dimensions-per-data-source']"
               [videos]="['managing-dimensions']"></app-help-page>
